import { useEffect, useState } from 'react';
import { api, logout } from '../lib/api.ts';
import { setSelectedBranchId } from '../store.tsx';
import { Alert, Spinner } from '../ui.tsx';
import type { Branch } from '../lib/types.ts';

/**
 * เลือกสาขาที่เครื่องนี้ใช้งาน
 *
 * พนักงานไม่เคยเห็นหน้านี้ — บัญชีพนักงานผูกกับสาขาไว้แล้วในฐานข้อมูล
 * มีแต่เจ้าของร้านที่เห็นทุกสาขา จึงต้องบอกว่ากำลังยืนอยู่ที่สาขาไหน
 * เพราะบิลที่เปิดต้องบันทึกลงสาขาที่ถูกต้อง
 */
export function BranchPickScreen({ onPicked }: { onPicked: (id: number) => void }) {
  const [branches, setBranches] = useState<Branch[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<{ branches: Branch[] }>('/branches')
      .then((r) => setBranches(r.branches))
      .catch((err: Error) => setError(err.message));
  }, []);

  if (error) {
    return (
      <div className="page">
        <Alert>{error}</Alert>
        <button className="btn ghost" onClick={logout}>ออกจากระบบ</button>
      </div>
    );
  }
  if (!branches) return <Spinner label="กำลังโหลดรายชื่อสาขา…" />;

  return (
    <div className="page" style={{ maxWidth: 520, paddingTop: 50 }}>
      <h1>เครื่องนี้อยู่สาขาไหน</h1>
      <p className="lede">เลือกครั้งเดียว ระบบจะจำไว้ให้</p>

      <div className="rowlist">
        {branches.map((branch) => (
          <button
            key={branch.id}
            className="rowitem"
            onClick={() => {
              setSelectedBranchId(branch.id);
              onPicked(branch.id);
            }}
          >
            <span className="grow">
              <strong>{branch.name}</strong>
              <div className="sub">รหัส {branch.code}</div>
            </span>
            <span>→</span>
          </button>
        ))}
      </div>

      <button className="btn quiet" style={{ marginTop: 24 }} onClick={logout}>
        ออกจากระบบ
      </button>
    </div>
  );
}
